import { Component } from '@angular/core';
@Component({
  selector: 'app-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrl: './global-loader.component.less',
})
export class GlobalLoaderComponent {
  constructor() {}
}
